import { api } from '@setplex/tria-api'
import { attach } from 'effector'

// *
// * EFFECTS
// *

export const getBannersFx = attach({ effect: api.banners.getBannersFx })
export const getFeaturedCarouselFx = attach({
  effect: api.banners.getFeaturedCarouselFx,
})
export const initCategoriesWithShowsFx = attach({
  effect: api.tvshows.initCategoriesWithShowsFx,
})
export const initShowBundlesRowByPageFx = attach({
  effect: api.showBundles.initShowBundlesRowByPageFx,
})
export const initInfiniteShowsCategoryFx = attach({
  effect: api.tvshows.initInfiniteShowsCategoryFx,
})
